export { default } from "bullitttime-embermodelsgochips/adapters/keypad-entry";
